module.exports = __webpack_public_path__ + "0f5bc6a220fda8202508241a36b3efb4.svg";